import { NbBooleanInput } from "@nebular/theme/components/helpers"

export class ClientModel {
    client_no: number
    last_name: string
    first_name: string
    middle_initial: string
    salutation: string
    home_phone: string
    work_phone: string
    work_phone_ext: string
    address: string
    city: string
    state: string
    zip: string
    zip4: string
    date_added: string
    active: string
    balance: number
    client_code: string
    last_visit: string
    modified_date: string
    contact_no: string
    contact_ext: string
    driver_license: string
    social_security: string
    credit_card_type: string
    credit_card: string
    expiration_date: string
    source: string
    county: string
    country: string
    year_to_date: number
    family_instructions: string
    allow_balance: boolean
    allow_check: boolean
    nonprofit: boolean
    email_address: string
    clinic_no: number
    tenant_no: number
    max_cashreg_date: string
    image_id:number
    client_email_id?: number
    Insuranceinfo?: string
    over_due?: number

    private _client_code_array: string[]

    set client_code_array(value: string[]) {
        this._client_code_array = value;
    }
    get client_code_array(): string[] {
        if (this.client_code && this.client_code.length > 0)
            return this.client_code.split('');
        return [];
    }

    constructor(
        client_no: number,
        last_name: string,
        first_name: string,
        middle_initial: string,
        salutation: string,
        home_phone: string,
        work_phone: string,
        work_phone_ext: string,
        address: string,
        city: string,
        state: string,
        zip: string,
        zip4: string,
        date_added: string,
        active: string,
        balance: number,
        client_code: string,
        last_visit: string,
        modified_date: string,
        contact_no: string,
        contact_ext: string,
        driver_license: string,
        social_security: string,
        credit_card_type: string,
        credit_card: string,
        expiration_date: string,
        source: string,
        county: string,
        year_to_date: number,
        family_instructions: string,
        allow_balance: boolean,
        allow_check: boolean,
        country: string,
        nonprofit: boolean,
        email_address: string,
        clinic_no: number,
        tenant_no: number,
        image_id:number,
        client_email_id: number,
        Insuranceinfo?: string,
        over_due?: number
    ) {
        this.client_no = client_no
        this.last_name = last_name
        this.first_name = first_name
        this.middle_initial = middle_initial
        this.salutation = salutation
        this.home_phone = home_phone
        this.work_phone = work_phone
        this.work_phone_ext = work_phone_ext
        this.address = address
        this.city = city
        this.state = state
        this.zip = zip
        this.zip4 = zip4
        this.date_added = date_added
        this.active = active
        this.balance = balance
        this.client_code = client_code
        this.last_visit = last_visit
        this.modified_date = modified_date
        this.contact_no = contact_no
        this.contact_ext = contact_ext
        this.driver_license = driver_license
        this.social_security = social_security
        this.credit_card_type = credit_card_type
        this.credit_card = credit_card
        this.expiration_date = expiration_date
        this.source = source
        this.county = county
        this.year_to_date = year_to_date
        this.family_instructions = family_instructions
        this.allow_balance = allow_balance
        this.allow_check = allow_check
        this.country = country
        this.nonprofit = nonprofit
        this.email_address = email_address
        this.clinic_no = clinic_no
        this.tenant_no = tenant_no
        this.image_id = image_id
        this.client_email_id = client_email_id
        this.Insuranceinfo = Insuranceinfo
        this.over_due = over_due
    }
}